// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ui-calendar-event-icon[data-v-11029706] {\n  width: 16px;\n  height: 16px;\n}\n.ui-calendar-event-icon[data-v-11029706] svg {\n  width: 100%;\n  height: 100%;\n}\n.ui-calendar-event-icon[data-v-11029706] span.empty {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: row;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
